module.exports = __webpack_public_path__ + "img/container5R.14352940.png";